// @flow
import React from 'react';
import { translate } from 'react-i18next';
import type { DateRange } from 'statsradio/domain/reach';

interface Props {
  dateRange: DateRange;

  className: ?string;
  t: any;
}

function MetricsDateRange({ dateRange, className, t }: Props) {
  return (
    <h3 className={className}>
      {t('date.dateRangeShortMonth', { from: dateRange.from, to: dateRange.to, separator: ' - ' })}
    </h3>
  );
}

export default translate()(MetricsDateRange);



// WEBPACK FOOTER //
// ./src/statsradio/modules/metrics/v2/components/reachMetricsOverview/MetricsDateRange.js